/**
 * Add and/or remove a body class
 * @param addClass
 * @param removeClass
 */
export const updateBodyClass = (addClass: string | null, removeClass?: string): void => {
  if (!document?.body) return
  if (addClass) {
    /* istanbul ignore next */
    document.body.classList.add(addClass)
  }
  if (removeClass) {
    /* istanbul ignore next */
    document.body.classList.remove(removeClass)
  }
}

/**
 * Add a data attribute to an element
 * @param {HTMLElement} element
 * @param {string} attribute
 * @param {string} value
 */
export const setDataAttribute = (element: HTMLElement, attribute: string, value: string): void => {
  if (!element) return
  /* istanbul ignore next */
  element.setAttribute(attribute, value)
}

/**
 * Remove data attribute from an element
 * @param {HTMLElement} element
 * @param {string} attribute
 */
export const removeDataAttribute = (element: HTMLElement, attribute: string): void => {
  if (!element) return
  /* istanbul ignore next */
  element.removeAttribute(attribute)
}
